<template>
  <div>
    <Headersys />
    <div class="content">
      <img v-if="count == 0" class="img-img" src="@/assets/useNotic/czsc_10.png" alt="">
      <img v-if="count == 1" class="img-img" src="@/assets/useNotic/czsc_11.png" alt="">
      <img v-if="count == 2" class="img-img" src="@/assets/useNotic/czsc_12.png" alt="">
      <img v-if="count == 3" class="img-img" src="@/assets/useNotic/czsc_13.png" alt="">
      <img v-if="count == 4" class="img-img" src="@/assets/useNotic/czsc_14.png" alt="">
      <img v-if="count == 5" class="img-img" src="@/assets/useNotic/czsc_15.png" alt="">
      <img v-if="count == 6" class="img-img" src="@/assets/useNotic/czsc_16.png" alt="">
      <img v-if="count == 7" class="img-img" src="@/assets/useNotic/czsc_17.png" alt="">
      <img v-if="count == 8" class="img-img" src="@/assets/useNotic/czsc_18.png" alt="">
      <img v-if="count == 9" class="img-img" src="@/assets/useNotic/czsc_19.png" alt="">
      <div v-if="count == 10">
        <img class="asd-img" src="@/assets/useNotic/asd.png" alt="">
        <div class="asd-title">请扫码下载爱山东APP进行业务办理</div>
      </div>
    </div>
    <Back print="4" @toNext="toNext" />
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      //
      count: 0
    };
  },
  created() {
    //
  },
  mounted() {
    //
  },
  methods: {
    //
    toNext() {
      if (this.count < 9) {
        this.count++
      } else {
        console.log('最后了');
        this.count = 10
      }
    }
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem - 40px);
  padding: 20px;
  background-color: #fff;
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  overflow-y: scroll;
}

.content::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.img-img {
  display: block;
  margin: auto;
}

.asd-img {
  display: block;
  margin: 90px auto 20px;
  width: 80rem;
}

.asd-title {
  font-size: 8rem;
  text-align: center;
  font-weight: bold;
}
</style>